import React from 'react'
import { motion } from 'framer-motion'
import Experience from '../components/Experience'
import './ExperiencePage.css'

const ExperiencePage = () => {
  return (
    <div className="experience-page">
      <div className="container">
        <motion.div
          className="page-header"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="page-title">My Experience</h1>
          <p className="page-description">
            A timeline of my professional journey and the valuable experiences that have shaped my career.
          </p>
        </motion.div>
        <Experience />
      </div>
    </div>
  )
}

export default ExperiencePage
